export default __webpack_public_path__ + "static/media/sepa.313bc3d9.jpg";